module.exports = __webpack_public_path__ + "static/media/1POLICY42.16a24588.jpg";